// constants
import { OPDServicesActionTypes } from './constants';
import { OPDService as OPDServiceData } from 'src/types/opdService';

export type OPDServicesActionType = {
    type:
        | OPDServicesActionTypes.API_RESPONSE_SUCCESS
        | OPDServicesActionTypes.API_RESPONSE_ERROR
        | OPDServicesActionTypes.ADD_OPD_SERVICE
        | OPDServicesActionTypes.EDIT_OPD_SERVICE
        | OPDServicesActionTypes.GET_OPD_SERVICES
        | OPDServicesActionTypes.GET_OPD_SERVICE
        | OPDServicesActionTypes.GET_SERVICES_DROPDOWN
        | OPDServicesActionTypes.DELETE_OPD_SERVICE
        | OPDServicesActionTypes.RESET
        | OPDServicesActionTypes.RESET_SUCCESS
        | OPDServicesActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const OPDServiceApiResponseSuccess = (
    actionType: string,
    data: OPDServiceData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): OPDServicesActionType => ({
    type: OPDServicesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const OPDServiceApiResponseError = (
    actionType: string,
    data: OPDServiceData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): OPDServicesActionType => ({
    type: OPDServicesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addOPDService = (params: any): OPDServicesActionType => ({
    type: OPDServicesActionTypes.ADD_OPD_SERVICE,
    payload: params,
});

export const editOPDService = (params: any): OPDServicesActionType => ({
    type: OPDServicesActionTypes.EDIT_OPD_SERVICE,
    payload: params,
});

export const GetOPDService = (params: any): OPDServicesActionType => ({
    type: OPDServicesActionTypes.GET_OPD_SERVICE,
    payload: params,
});

export const GetOPDServices = (params: any): OPDServicesActionType => ({
    type: OPDServicesActionTypes.GET_OPD_SERVICES,
    payload: params,
});

export const GetServicesDropDown = (params: any): OPDServicesActionType => ({
    type: OPDServicesActionTypes.GET_SERVICES_DROPDOWN,
    payload: params,
});

export const deletePDService = (params: any): OPDServicesActionType => ({
    type: OPDServicesActionTypes.DELETE_OPD_SERVICE,
    payload: params,
});

export const resetOPDService = (): OPDServicesActionType => ({
    type: OPDServicesActionTypes.RESET,
    payload: {},
});

export const resetOPDServiceSuccess = (): OPDServicesActionType => ({
    type: OPDServicesActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetOPDServiceError = (): OPDServicesActionType => ({
    type: OPDServicesActionTypes.RESET_ERROR,
    payload: {},
});
